import { Link } from "react-router-dom";
import { testimonials } from "@/mocks/site";

export default function AboutVoices() {
  const picked = testimonials.slice(2, 5);

  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="max-w-2xl">
          <p className="text-xs font-medium tracking-widest text-secondary-700">VOICES · 用户口碑</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            读者的真实反馈
          </h2>
        </div>
        <Link
          to="/contact"
          className="inline-flex items-center gap-1 text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
        >
          也想说两句
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-3">
        {picked.map((item) => (
          <blockquote
            key={item.name}
            className="flex flex-col rounded-lg border-l-4 border-primary-400 bg-background-100 p-5 md:p-6"
          >
            <p className="flex-1 text-sm leading-relaxed text-foreground-700">“{item.text}”</p>
            <footer className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                {item.initial}
              </span>
              <span className="flex flex-col">
                <span className="text-sm font-medium text-foreground-900">{item.name}</span>
                <span className="text-xs text-foreground-500">{item.role}</span>
              </span>
            </footer>
          </blockquote>
        ))}
      </div>
    </section>
  );
}